<template>
    <!-- Componente para mostrar los botones de la sección de TyC de las promociones -->
    <div
        v-if="modelUrl"
        class="flex flex-col md:flex-row space-y-4 md:space-y-0 mb-1 justify-center -mt-4"
    >
        <div>
            <a
                class="block w-64 lg:w-40 text-center bg-gray text-white text-sm py-2 mx-auto"
                :href="`${url}/${webpage}/modelos/configura-una-version/${modelUrl}`"
            >Conoce más</a>
        </div>
        <div class="md:ml-4">
            <a
                class="block w-64 lg:w-40 text-center bg-dark-blue text-white text-sm py-2 mx-auto"
                :href="`${url}/${webpage}/modelos/formulario-cotizacion/${modelUrl}`"
            >Solicitar cotización</a>
        </div>
    </div>
</template>

<script>
export default {
    props: [
        "model_url",
    ],
    data() {
        return {
            url: $('.url').text(),
            webpage: $('.webpage').text(),
            // modelUrl: $('.model-url').text(),
            modelUrl: this.model_url != "" ? this.model_url : $('.model-url').text(),
        }
    }
}
</script>

<style>
</style>
